export default "__VITE_ASSET__CJNd$LgF__";